import React from "react";
import {useAxiosSetup} from "../Api";
import {toast} from "react-toastify";
import PopupWarning from "../dialogs/PopupWarning";
import {useModal} from "../dialogs/ModalContext";

function NextBtkButton(props) {

    const api = useAxiosSetup();
    const {showModal} = useModal();

    function addNextBtk() {
        const oldBtkData = props.data
        let newBtkData = {}
        newBtkData.Datum_Planovanej_BTK = oldBtkData.Nasledujuca_Kontrola
        newBtkData.Cislo_Predoslej = oldBtkData.Cislo
        api.post('btk/btks/plan_btk/', newBtkData).then((response) => {
            const nextBtk = response.data.Cislo
            const nextBtkId = response.data.id
            window.open(`${nextBtkId}`, '_blank', 'noopener,noreferrer')
        }).catch((error) => {
            showModal(PopupWarning, "\"Nepodarilo sa naplánovať nasledujúcu BTK!.", () => {});
        })
    }

    return (
        <button type="button" className="btn btn-outline-primary btn-md hugeButton" style={{"opacity": "0.8"}} onClick={addNextBtk}>
            <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" fill="currentColor"
                 className="bi bi-plus-lg buttonImage" viewBox="0 0 16 16">
                <path fillRule="evenodd"
                      d="M8 2a.5.5 0 0 1 .5.5v5h5a.5.5 0 0 1 0 1h-5v5a.5.5 0 0 1-1 0v-5h-5a.5.5 0 0 1 0-1h5v-5A.5.5 0 0 1 8 2Z"/>
            </svg>Nasl. BTK
        </button >
    )
}

export default NextBtkButton
